/* product thumbnail strip - travelling active indicator */

(function () {
  'use strict';

  var TRACK = '.product-information .slideshow-controls__thumbnails';
  var THUMB = '.slideshow-controls__thumbnail';
  var SELECTED = THUMB + '[aria-selected="true"]';
  var INDICATOR = 'yg-thumb-indicator';
  var ON = 'yg-thumb-indicator--on';
  var ARMED = 'yg-thumb-indicator--armed';

  var states = new WeakMap();
  var swaps = new MutationObserver(scan);
  var scanQueued = false;

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(function () {
      scanQueued = false;
      scan();
    });
  }

  function scan() {
    var tracks = document.querySelectorAll(TRACK);

    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];

      /* media-gallery.js replaces the whole <media-gallery> on a variant change
         - watch the parent to pick up whatever replaces it */
      var gallery = track.closest('media-gallery');
      if (gallery && gallery.parentElement) swaps.observe(gallery.parentElement, { childList: true });

      if (states.has(track)) continue;
      attach(track);
    }
  }

  /**
   * @param {Element} track
   */
  function attach(track) {
    var el = document.createElement('span');
    el.className = INDICATOR;
    /* decoration only - the thumbnails carry the selected state */
    el.setAttribute('aria-hidden', 'true');

    var state = {
      track: track,
      el: el,
      armed: false,
      queued: false,
      snap: true,
    };
    states.set(track, state);

    /* set before the node lands so the observer can tell our own insertion
       from a gallery re-render */
    state.writing = true;
    track.appendChild(el);
    state.writing = false;

    /* aria-selected is the move; a childList change is a re-render, where the
       tracked thumbnail may no longer exist - snap, never travel */
    var watcher = new MutationObserver(function (records) {
      var snap = false;
      var relevant = false;

      for (var i = 0; i < records.length; i++) {
        var record = records[i];

        if (record.type === 'attributes') {
          relevant = true;
          continue;
        }
        if (state.writing || ours(record, el)) continue;

        relevant = true;
        snap = true;
      }

      if (!relevant) return;
      /* The indicator is a child of the track, so a re-render can drop it. */
      if (!el.isConnected) {
        state.writing = true;
        track.appendChild(el);
        state.writing = false;
      }
      queueMeasure(state, snap);
    });

    watcher.observe(track, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-selected'],
    });

    /* Thumbnails are observed individually because the gallery's aspect ratio
       is Auto, so an image can resolve its own ratio after the track has
       already been sized. A resize snaps rather than travels. */
    var sizes = new ResizeObserver(function () {
      queueMeasure(state, true);
    });
    sizes.observe(track);

    var thumbs = track.querySelectorAll(THUMB);
    for (var i = 0; i < thumbs.length; i++) sizes.observe(thumbs[i]);

    queueMeasure(state, true);
  }

  /**
   * Whether a childList record is this file putting its own indicator back.
   *
   * @param {MutationRecord} record
   * @param {Element} el
   * @returns {boolean}
   */
  function ours(record, el) {
    var i;

    for (i = 0; i < record.addedNodes.length; i++) {
      if (record.addedNodes[i] !== el) return false;
    }
    for (i = 0; i < record.removedNodes.length; i++) {
      if (record.removedNodes[i] !== el) return false;
    }

    return record.addedNodes.length + record.removedNodes.length > 0;
  }

  /**
   * @param {object} state
   * @param {boolean} snap
   */
  function queueMeasure(state, snap) {
    state.snap = state.snap || snap;
    if (state.queued) return;
    state.queued = true;

    requestAnimationFrame(function () {
      state.queued = false;
      var wanted = state.snap;
      state.snap = false;
      measure(state, wanted);
    });
  }

  /**
   * @param {object} state
   * @param {boolean} snap
   */
  function measure(state, snap) {
    var el = state.el;
    var thumb = state.track.querySelector(SELECTED);

    /* offsetParent is null under display:none, where every offset reads 0 and
       would park the box in the corner - drop it and let the resize that
       brings the strip back snap it into place */
    if (!thumb || !thumb.offsetParent) {
      el.classList.remove(ON, ARMED);
      state.armed = false;
      return;
    }

    if (snap) disarm(state);

    el.style.setProperty('--yg-thumb-x', thumb.offsetLeft + 'px');
    el.style.setProperty('--yg-thumb-y', thumb.offsetTop + 'px');
    el.style.setProperty('--yg-thumb-w', thumb.offsetWidth + 'px');
    el.style.setProperty('--yg-thumb-h', thumb.offsetHeight + 'px');
    el.classList.add(ON);

    if (!state.armed) arm(state);
  }

  /**
   * Takes the transition off and flushes that, so the placement that follows
   * lands rather than travels.
   *
   * @param {object} state
   */
  function disarm(state) {
    if (!state.armed) return;
    state.armed = false;
    state.el.classList.remove(ARMED);
    void state.el.offsetWidth;
  }

  /**
   * Puts the transition back a frame later, once the placement it must not
   * animate has already been painted.
   *
   * @param {object} state
   */
  function arm(state) {
    if (state.arming) return;
    state.arming = true;

    requestAnimationFrame(function () {
      state.arming = false;
      if (!state.el.classList.contains(ON)) return;
      state.armed = true;
      state.el.classList.add(ARMED);
    });
  }

  document.addEventListener('shopify:section:load', queueScan);
  document.addEventListener('shopify:section:unload', queueScan);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
